import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { OfferExpectation, OfferPersonal } from '../interfaces/offer.interface';
import { Contact } from '../interfaces/contact.interface';

@Injectable()
export class SlackService {
	protected slackUrl: string = 'https://www.capdesign.hu/services/aquaapartman/slack.php';
	protected token: string = 'a4zC22uKFLiAkbx6QcP7';

	constructor(private http: Http) { }

	public sendOffer(expectation: OfferExpectation, personal: OfferPersonal) {
		let message = this.formatOfferMessage(expectation, personal);
		let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
		let options = new RequestOptions({ headers: headers });
		return this.http.post(this.slackUrl, 'token=' + this.token + '&message=' + message, options)
			.subscribe(response => {
				//console.log('POST response: %o', response);
			}, error => {
				console.log(JSON.stringify(error.json()));
			}
		);
	}

	public sendContact(contact: Contact) {
		let message = this.formatContactMessage(contact);
		let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
		let options = new RequestOptions({ headers: headers });
		return this.http.post(this.slackUrl, 'token=' + this.token + '&message=' + message, options)
			.subscribe(response => {
				//console.log('POST response: %o', response);
			}, error => {
				console.log(JSON.stringify(error.json()));
			}
		);
	}

	private formatOfferMessage(expectation: OfferExpectation, personal: OfferPersonal): string {
		let messageJson = `{"text":"Új ajánlatkérés","attachments":[{"title":"FOGLALÁSI ADATOK","fields":[`;
		if (expectation.arrival) messageJson += '{"title":"Érkezés:","value":"' + expectation.arrival.toDateString() + '","short":true},';
		if (expectation.departure) messageJson += '{"title":"Távozás:","value":"' + expectation.departure.toDateString() + '","short":true},';
		if (expectation.adult) messageJson += `{"title":"Felnőtt:","value":"${expectation.adult}","short":true},`;
		if (expectation.child) messageJson += `{"title":"Gyermek (2-16):","value":"${expectation.child}","short":true},`;
		if (expectation.baby) messageJson += `{"title":"Gyermek (0-2):","value":"${expectation.baby}","short":true},`;
		messageJson += `]},`;
		messageJson += `{"title":"KAPCSOLATI ADATOK","fields":[`;
		if (personal.name) messageJson += `{"title":"Név:","value":"${personal.name}","short":false},`;
		if (personal.phone) messageJson += `{"title":"Telefonszám:","value":"${personal.phone}","short":true},`;
		if (personal.email) messageJson += `{"title":"E-mail cím:","value":"${personal.email}","short":true},`;
		if (personal.message) messageJson += `{"title":"Üzenet:","value":"${personal.message}","short":false},`;
		if (personal.promotion === true) {
			messageJson += `{"title":"Akciók:","value":"igen","short":true},`;
		}
		else {
			messageJson += `{"title":"Akciók:","value":"nem","short":true},`;
		}
		messageJson += `]}]}`;
		return messageJson;
	}

	private formatContactMessage(contact: Contact): string {
		let messageJson = `{"text":"Új kapcsolatfelvétel","attachments":[{"title":"KAPCSOLATI ADATOK","fields":[`;
		if (contact.name) messageJson += `{"title":"Név:","value":"${contact.name}","short":true},`;
		if (contact.phone) messageJson += `{"title":"Telefonszám:","value":"${contact.phone}","short":true},`;
		if (contact.email) messageJson += `{"title":"E-mail cím:","value":"${contact.email}","short":true},`;
		if (contact.message) messageJson += `{"title":"Üzenet:","value":"${contact.message}","short":false},`;
		messageJson += `]}]}`;
		return messageJson;
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/services/slack.service.ts